/* corex-textil-editor-groups.js · Agrupa los elementos de una vista en impresiones (sin DOM).
   En delante/detrás el cliente coloca elementos sueltos (cm de prenda: x desde el eje, + a la derecha de la imagen;
   y desde el cuello hacia abajo, en el centro del elemento). Los elementos cuyas cajas quedan a menos de GAP_CM se
   imprimen juntos: forman una impresión, que se cobra por su caja real como antes. El resultado tiene la forma de las
   impresiones de siempre ({ id, size, dist, dx, layers } con capas relativas al centro del área libre), así que
   escalado, precios, carrito y archivos no cambian. */
(function (global) {
  'use strict';

  var GAP_CM = 2;
  var EPS = 1e-6;

  /* Caja { x0, x1, y0, y1 } de unas esquinas { x, y }. */
  function boxOf(points) {
    var xs = points.map(function (p) { return p.x; }), ys = points.map(function (p) { return p.y; });
    return { x0: Math.min.apply(null, xs), x1: Math.max.apply(null, xs), y0: Math.min.apply(null, ys), y1: Math.max.apply(null, ys) };
  }
  function union(boxes) {
    return boxes.reduce(function (u, b) {
      return u ? { x0: Math.min(u.x0, b.x0), x1: Math.max(u.x1, b.x1), y0: Math.min(u.y0, b.y0), y1: Math.max(u.y1, b.y1) }
        : { x0: b.x0, x1: b.x1, y0: b.y0, y1: b.y1 };
    }, null);
  }
  /* Separación entre dos cajas (0 si se tocan o solapan): la mayor de la horizontal y la vertical. */
  function gapBetween(a, b) {
    var dx = Math.max(0, b.x0 - a.x1, a.x0 - b.x1), dy = Math.max(0, b.y0 - a.y1, a.y0 - b.y1);
    return Math.max(dx, dy);
  }

  /* Índices de capas por grupo. boxes: [{ x0, x1, y0, y1, hidden }]. Las visibles se unen si están a menos de gap
     (también en cadena); las ocultas van con el grupo más cercano (no cuentan para la caja ni para unir).
     Grupos ordenados de arriba abajo y de izquierda a derecha. */
  function cluster(boxes, gap) {
    var g = gap == null ? GAP_CM : gap, parent = boxes.map(function (b, i) { return i; });
    var find = function (i) { while (parent[i] !== i) { parent[i] = parent[parent[i]]; i = parent[i]; } return i; };
    var visible = boxes.map(function (b, i) { return i; }).filter(function (i) { return !boxes[i].hidden; });
    visible.forEach(function (i, a) {
      visible.slice(a + 1).forEach(function (j) {
        if (gapBetween(boxes[i], boxes[j]) < g - EPS) parent[find(i)] = find(j);
      });
    });
    var byRoot = {};
    visible.forEach(function (i) { var r = find(i); (byRoot[r] = byRoot[r] || []).push(i); });
    var groups = Object.keys(byRoot).map(function (r) { return byRoot[r]; });
    var boxOfGroup = function (idx) { return union(idx.map(function (i) { return boxes[i]; })); };
    boxes.forEach(function (b, i) {
      if (!b.hidden || !groups.length) return;
      var best = groups.slice().sort(function (p, q) { return gapBetween(b, boxOfGroup(p)) - gapBetween(b, boxOfGroup(q)); })[0];
      best.push(i);
    });
    var key = function (idx) { var u = boxOfGroup(idx.filter(function (i) { return !boxes[i].hidden; })); return [Math.round(u.y0 * 100), Math.round(u.x0 * 100)]; };
    return groups.map(function (idx) { return idx.sort(function (a, b) { return a - b; }); })
      .sort(function (p, q) { var a = key(p), b = key(q); return a[0] - b[0] || a[1] - b[1]; });
  }

  /* Impresiones de una vista a partir de sus elementos.
     o: { viewId, items (capas en cm de prenda), corners(capa) → esquinas, size (área libre, p. ej. '40x50'),
          areaH (alto de esa área), gap }.
     Cada impresión: el área libre centrada en la caja de su diseño (dist = borde superior del área, dx = centro),
     capas en el orden de la vista y relativas a ese centro. */
  function derivePrints(o) {
    var boxes = o.items.map(function (l) { return Object.assign({ hidden: !!l.hidden }, boxOf(o.corners(l))); });
    return cluster(boxes, o.gap).map(function (idx, k) {
      var u = union(idx.filter(function (i) { return !boxes[i].hidden; }).map(function (i) { return boxes[i]; }));
      var cx = (u.x0 + u.x1) / 2, cy = (u.y0 + u.y1) / 2;
      return {
        id: o.viewId + '-' + (k + 1), size: o.size, dist: cy - o.areaH / 2, dx: cx,
        layers: idx.map(function (i) { var l = o.items[i]; return Object.assign({}, l, { x: l.x - cx, y: l.y - cy }); }),
        itemIds: idx.map(function (i) { return o.items[i].id; }),
        box: u
      };
    });
  }

  var api = { GAP_CM: GAP_CM, boxOf: boxOf, union: union, gapBetween: gapBetween, cluster: cluster, derivePrints: derivePrints };
  if (typeof module === 'object' && module.exports) module.exports = api;
  else global.CorexTextilGroups = api;
})(this);
